"use client";

import type { RootProduct } from "@raumagarn/formatters";
import { usePrice } from "~/lib/hooks/usePrice";
import { formatPrice } from "~/lib/utils/price";

interface IPriceProps {
	pricelist: RootProduct["pricelist"] | undefined;
}

export const Price = ({ pricelist }: IPriceProps) => {
	const { price, priceBeforeDiscount, showAsOnSale } = usePrice({ pricelist });

	const isOnSale = showAsOnSale || price !== priceBeforeDiscount;

	return (
		<strong data-layout="price">
			{formatPrice(price)} {isOnSale && <span>{formatPrice(priceBeforeDiscount)}</span>}
		</strong>
	);
};
